// Package imports:
import React from 'react';
// Component imports:
import DisplayBox from '../../ui-elements/DisplayBox/DisplayBox';
import Tabs from '../../ui-elements/Tabs/Tabs';
import OMX from './OMX/OMX';
import ETF from './ETF/ETF';
import FirstNorth from './FirstNorth/FirstNorth';
import ValinHlutabref from './ValinHlutabref/ValinHlutabref';
import OllHlutabref from './OllHlutabref/OllHlutabref';
import DelayOrClosedLabel from '../DelayOrClosedLabel/DelayOrClosedLabel';
// Service imports:
import { CUSTOM_REFRESH_RATES } from '../../services/config';
// Type imports:
import { IDefaultProps } from '../../types/Types';
import { IApiLmdTradableFull, IApiTickSizeTableEntry } from '../../types/HlutabrefTypes';

type Props = IDefaultProps & React.HTMLAttributes<HTMLDivElement>;

const Hlutabref: React.FC<Props> = ({
    accessToken,
    refreshRateMs,
    ...props
}) => {
    const [tradables, setTradables] = React.useState<IApiLmdTradableFull[] | null>(null);
    const [tickSizeTables, setTickSizeTables] = React.useState<IApiTickSizeTableEntry[] | null>(null);
    const defaultProps = {
        accessToken,
        refreshRateMs: CUSTOM_REFRESH_RATES['HLUTABREF'],
        tradables,
        tickSizeTables,
    };
    React.useEffect(() => {
        fetch('/Home/GetTradables')
            .then(res => res.json())
            .then(data => setTradables(data))
            .catch(err => console.error('Failed to fetch tradables:', err));

        fetch('/Home/GetTickSizeTables')
            .then(res => res.json())
            .then(data => setTickSizeTables(data))
            .catch(err => console.error('Failed to fetch tick size tables:', err));
    }, []); 
    return (
        <DisplayBox
            className='KCL_Hlutabref'
            anchorProps={{ href: '/Markadir/Hlutabref' }}
            title="Hlutabréf"
            statusComponent={<DelayOrClosedLabel />}
            displayBoxSize="sm"
            {...props}
        >
            <Tabs
                tabs={[{
                    id: `${props.id}-omx`,
                    label: "XICE",
                    component: <OMX {...defaultProps} />
                }, {
                    id: `${props.id}-firstNorth`,
                    label: "First North",
                    component: <FirstNorth {...defaultProps}/>
                }, {
                    id: `${props.id}-ollHlutabref`,
                    label: "Öll hlutabréf",
                    component: <OllHlutabref {...defaultProps}/>
                }, {
                    id: `${props.id}-ETF`,
                    label: "ETF",
                    component: <ETF {...defaultProps}/>
                }, {
                    id: `${props.id}-valinHlutabref`,
                    label: "Valin hlutabréf",
                    component: <ValinHlutabref {...defaultProps}/>
                }]}
            />
        </DisplayBox>
    );
}

export default Hlutabref;